import React from "react";
import { C } from "../theme";

export default function Card({ children, style = {}, glow, ...rest }) {
  return (
    <div
      {...rest}
      style={{
        background: C.cardBg,
        borderRadius: 12,
        border: `1px solid ${glow || C.border}`,
        boxShadow: glow ? `0 0 18px ${glow}28` : "none",
        overflow: "hidden",
        ...style,
      }}
    >
      {children}
    </div>
  );
}
